import { useState, type HTMLAttributes } from 'react';
/** CSS collapses only the phone summary; children stay mounted on resize. */
export function BuilderSummary({ children, ...props }: HTMLAttributes<HTMLElement>) {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <aside {...props} data-collapsed={collapsed}>
      <button
        type="button"
        className="builder-summary-toggle"
        aria-expanded={!collapsed}
        onClick={() => setCollapsed(!collapsed)}
      >
        Summary &amp; guidance <span aria-hidden="true">{collapsed ? '+' : '−'}</span>
      </button>
      {children}
    </aside>
  );
}
